// extracted by mini-css-extract-plugin
export var fadeInOut = "_m-3";
export var icon = "_m-4";
export var savedIndicator = "_m-2";
export var savingIndicator = "_m-0";
export var spin = "_m-1";